'use client';

import { GetResponseType } from '@/api/types/api';
import { ApiResponseDefinition } from '@/api/types/api-definition';
import { EPlatform } from '@/utils/enums/platform-enum';
import dynamic from 'next/dynamic';
import { FC } from 'react';

const FooterV2 = dynamic(() => import('./index'), { ssr: true });
const FooterV2ClientOnly = dynamic(() => import('./index'), { ssr: false });

interface ClientFooterWrapperProps {
  isBot: boolean;
  deviceType: EPlatform;
  navList: GetResponseType<ApiResponseDefinition['GET:/api/nav/lists']>;
}

const ClientFooterWrapper: FC<ClientFooterWrapperProps> = ({ isBot, deviceType, navList }) => {
  if (isBot) {
    return <FooterV2 deviceType={deviceType} navList={navList} />;
  }

  return <FooterV2ClientOnly deviceType={deviceType} navList={navList} />;
};

export default ClientFooterWrapper;
